// gym/GymAttendance.jsx
import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const GymAttendance = () => {
  return (
    <Box p={3}>
      <Typography variant="h4">Présences</Typography>
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography>Page en construction...</Typography>
      </Paper>
    </Box>
  );
};

export default GymAttendance;